var _a;
export default class BrowserAlert {
}
_a = BrowserAlert;
BrowserAlert.TEXT_LIMIT_NUMBER = 100;
BrowserAlert.TEXTAREA_LIMIT_NUMBER = 2000;
BrowserAlert.charLimitText = (target, max = BrowserAlert.TEXT_LIMIT_NUMBER) => {
    return _a._cLimit(target !== null && target !== void 0 ? target : '', max);
};
BrowserAlert.charLimitTextArea = (target, max = BrowserAlert.TEXTAREA_LIMIT_NUMBER) => {
    return _a._cLimit(target !== null && target !== void 0 ? target : '', max);
};
BrowserAlert._cLimit = (target, max) => {
    if (max < target.length) {
        alert(`${max}文字以内でお書きください`);
        return true;
    }
    return false;
};
BrowserAlert.Error = (message) => {
    alert(message);
};
BrowserAlert.RequestError = (status) => {
    switch (status) {
        case 401:
            alert('認証に失敗したかアクセス権限がありません');
            break;
        case 403:
            alert('アクセスを拒否されました');
            break;
        case 404:
            alert('アクセス先が見つかりませんでした');
            break;
        case 408:
            alert('サーバーからの応答がありません');
            break;
        // case 419:
        //     alert('有効期限が過ぎました\nページを再読み込みしてください');
        //     break;
        case 422:
            // alert('間違った入力をしている可能性があります\n入力内容を確認しもう一度実行してください');
            break;
        case 500:
            alert('サーバーでエラーが発生しました\nシステム管理者に連絡してください');
            break;
    }
};
